import { render, staticRenderFns } from "./settingManage.vue?vue&type=template&id=5fd0ebf6&scoped=true&"
import script from "./settingManage.vue?vue&type=script&lang=js&"
export * from "./settingManage.vue?vue&type=script&lang=js&"
import style0 from "./settingManage.vue?vue&type=style&index=0&id=5fd0ebf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0ebf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd0ebf6')) {
      api.createRecord('5fd0ebf6', component.options)
    } else {
      api.reload('5fd0ebf6', component.options)
    }
    module.hot.accept("./settingManage.vue?vue&type=template&id=5fd0ebf6&scoped=true&", function () {
      api.rerender('5fd0ebf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/settingManage.vue"
export default component.exports